/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DataDialogPromptStatus } from './DataDialogPromptStatus';
import {
    DataDialogPromptStatusFromJSON,
    DataDialogPromptStatusFromJSONTyped,
    DataDialogPromptStatusToJSON,
} from './DataDialogPromptStatus';

/**
 * 
 * @export
 * @interface UpdateDataDialogPromptRequestContent
 */
export interface UpdateDataDialogPromptRequestContent {
    /**
     * 
     * @type {string}
     * @memberof UpdateDataDialogPromptRequestContent
     */
    promptText: string;
    /**
     * 
     * @type {DataDialogPromptStatus}
     * @memberof UpdateDataDialogPromptRequestContent
     */
    promptStatus: DataDialogPromptStatus;
}


/**
 * Check if a given object implements the UpdateDataDialogPromptRequestContent interface.
 */
export function instanceOfUpdateDataDialogPromptRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "promptText" in value;
    isInstance = isInstance && "promptStatus" in value;

    return isInstance;
}

export function UpdateDataDialogPromptRequestContentFromJSON(json: any): UpdateDataDialogPromptRequestContent {
    return UpdateDataDialogPromptRequestContentFromJSONTyped(json, false);
}

export function UpdateDataDialogPromptRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDataDialogPromptRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'promptText': json['promptText'],
        'promptStatus': DataDialogPromptStatusFromJSON(json['promptStatus']),
    };
}

export function UpdateDataDialogPromptRequestContentToJSON(value?: UpdateDataDialogPromptRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'promptText': value.promptText,
        'promptStatus': DataDialogPromptStatusToJSON(value.promptStatus),
    };
}

